import { Model } from '@vuex-orm/core'

export default class CalendarEvent extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'calendarEvents'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      candidate_id: this.attr(null),
      events: this.attr(null),
      job_id: this.attr(null),
      stage_id: this.attr(null),
      type: this.attr(null),
      location: this.attr(null),
      summary: this.attr(null),
      note: this.attr(null),
      assigned_users: this.attr(null),
      participants: this.attr(null),
      start_at: this.attr(null),
      duration: this.attr(null),
      my_event: this.attr(null),
      internal: this.attr(null),
      meet_link: this.attr(null),
      scoreform_id: this.attr(null),
      group_key: this.attr(null),
      author_user_id: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/CalendarEvent.js